module.exports = __webpack_public_path__ + "img/leftthigh.ae2da0a8.svg";